// Ensure window.googletag exists for ads purposes
require('./googletag');

// Ensure window.jagvars exists for ads purposes
global.jagvars = {};
global.jSite = 'alst.home.dfp';
global.jAdUnit = '';
